import { render, staticRenderFns } from "./FinishProcess.vue?vue&type=template&id=020a4ff7&scoped=true"
import script from "./FinishProcess.vue?vue&type=script&lang=js"
export * from "./FinishProcess.vue?vue&type=script&lang=js"
import style0 from "./FinishProcess.vue?vue&type=style&index=0&id=020a4ff7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a4ff7",
  null
  
)

export default component.exports